import { Injectable, signal, computed } from '@angular/core';
import { PaymentCard } from '../models/payment-card.model';
import { VerificationStatus } from '../models/verification-status.model';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private verificationStatus = signal<VerificationStatus | null>(null);
  private selectedCard = signal<PaymentCard | null>(null);

  readonly verificationStatus$ = this.verificationStatus.asReadonly();
  readonly selectedCard$ = this.selectedCard.asReadonly();

  readonly canComplete = computed(() => {
    const status = this.verificationStatus();
    if (!status) return false;
    return status.can_complete;
  });

  readonly biometricRequired = computed(() => {
    const status = this.verificationStatus();
    if (!status) return false;
    return status.biometric_required;
  });

  readonly biometricCompleted = computed(() => {
    const status = this.verificationStatus();
    if (!status) return false;
    return status.biometric_completed;
  });

  readonly hasPaymentCard = computed(() => {
    const status = this.verificationStatus();
    if (!status) return false;
    return status.payment_card_id !== null;
  });

  setVerificationStatus(status: VerificationStatus): void {
    this.verificationStatus.set(status);
  }

  setSelectedCard(card: PaymentCard): void {
    this.selectedCard.set(card);
  }

  clearState(): void {
    this.verificationStatus.set(null);
    this.selectedCard.set(null);
  }
}
